// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-o_fK","advertDetailContacts__header":"c-o_fL"};